// extracted by mini-css-extract-plugin
module.exports = {"root":"FiltersPanelHead_root__c8M_d","title":"FiltersPanelHead_title__Eg7Xy","controls":"FiltersPanelHead_controls__q_mKj","back":"FiltersPanelHead_back__TYReW"};